import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Explore_Btn from "../../common-components/common-btn/explore_btn/Explore_Btn";
import "./Banner.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

function Banner() {
  const data = [
    "/assets/images/home/banner/img1.png",
    "/assets/images/home/banner/img2.png",
    "/assets/images/home/banner/img3.png",
    "/assets/images/home/banner/img4.png",
    "/assets/images/home/banner/img5.png",
    "/assets/images/home/banner/img6.png",
    "/assets/images/home/banner/img7.png",
    "/assets/images/home/banner/img3.png",
    "/assets/images/home/banner/img4.png",
    "/assets/images/home/banner/img5.png",
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const navigate = useNavigate();

  return (
    <section className="Banner">
      <div className="container-fluid p-0">
        <div className="all_divs_holder">
          <div className="vdo_holder">
            <video
              src="/assets/videos/home_vdo.mp4"
              autoPlay
              muted
              loop
              playsInline
              className="myVideo"
            />
          </div>

          <div className="overlay"></div>

          <div className="inner_content_div">
            <div className="container">
              <div className="main_swiper_div">
                <p className="white_text">Unlock Your Potential with </p>
                <p className="orange_text">Sports & Fitness</p>

                <div className="imgs_swiper">
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    centeredSlides={true}
                    loop={true}
                    onSlideChange={(swiper) => {
                      document
                        .querySelectorAll(".swiper-slide")
                        .forEach((el) => {
                          el.classList.remove("prev-2", "prev-3");
                        });

                      const slides = swiper.slides;
                      const activeIndex = swiper.activeIndex;

                      console.log("activeIndex", activeIndex);

                      if (slides[activeIndex - 2])
                        slides[activeIndex - 2].classList.add("prev-2");
                      if (slides[activeIndex - 3])
                        slides[activeIndex - 3].classList.add("prev-3");
                    }}
                    autoplay={{
                      delay: 1500,
                      disableOnInteraction: false,
                    }}
                    modules={[Navigation, Autoplay]}
                    breakpoints={{
                      0: {
                        slidesPerView: 2,
                        spaceBetween: 8,
                      },
                      575: {
                        slidesPerView: 2.5,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                      },
                      992: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                      },
                      1200: {
                        slidesPerView: 5,
                        spaceBetween: 20,
                      },
                      1400: {
                        slidesPerView: 7,
                        spaceBetween: 20,
                      },
                    }}
                    className="mySwiper"
                  >
                    {data.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className={`inner_img_holder ${
                            index === activeIndex
                              ? "swiper-slide-active-custom"
                              : ""
                          }`}
                        >
                          <img
                            src={process.env.PUBLIC_URL + item}
                            alt=""
                            className="swiper_img"
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                <div className="explore_btn">
                  <Explore_Btn
                    btnText="Explore Sports"
                    onClick={() => {
                      navigate("/sports-programs");
                    }}
                  />
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
